<template>
  <div class="table-box" :v-if="group.length > 0">
      <div class="table-list" v-for="(g,index) in group" :key="index" >
        <div class="fenge" v-if="index !== 0">&nbsp;</div>
        <table cellspacing="1">
            <tr class="toptr">
                <td v-text="g.name" style="width:200px"></td>
                <td>评分层级</td>
                <td>反馈人数</td>
                <td v-for="(c,cindex) in config" :key="cindex" class="topChengdu" :class="setClass('topChengdu',cindex)">
                    <div class="line-top">{{c.min}}-{{c.max}}</div>
                    <div class="line-bottom" v-text="c.name"></div>
                </td>
                <td>加权平均</td>
                <td>排名</td>
            </tr>
            <tbody v-for="(gl,index2) in g.list" :key="index2" cellspace="3">
                <tr class="middle">
                    <td rowspan="3" class="left">
                        <div class="index"><span v-text="gl.index"></span><span v-text="gl.name"></span></div>
                        <div v-text="gl.title"></div>
                    </td>
                    <td>{{gl.tItems && gl.tItems.name}}</td>
                    <td>{{gl.tItems && gl.tItems.num}}</td>
                    <td v-for="(c,cindex) in config"  :key="cindex" class="chengdu" :class="setClass('chengdu',cindex)">
                        <span :class="setShowClass(c,gl.tItems)"></span>
                    </td>
                    <td class="score">
                        {{gl.tItems && gl.tItems.value}}
                    </td>
                    <td rowspan="3">
                        <div v-text="g.ranking"></div>
                    </td>
                </tr>
                <tr class="middle" v-for="(c,cindex) in gl.items" :key="cindex">
                    <td>{{c.name}}</td>
                    <td>{{c.num}}</td>
                    <td v-for="(g,cindex) in config" class="chengdu" :class="setClass('chengdu',cindex)" :key="cindex">
                        <span :class="setShowClass(g,c)"></span>
                    </td>
                    <td class="score">
                        {{c.value}}
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
  </div>
</template>

<script>
import { groups,groupsConfig } from './config'
export default {
  props: ["model","configure"],
  data() {
    return {
      group:groups,
      config:groupsConfig
    };
  },
  mounted() {
    if (this.model) {
      this.group = this.model;
    }
    if (this.configure) {
      this.config = this.configure;
    }
    this.renderTable()
  },
  methods:{
      setClass(className,index){
          return className + (index + 1)
      },
      setRageDot(index){
          return 'left:' + index + 'px'
      },
      setRageBox(index){
          return 'left:' + index + 'px'
      },
      setShowClass(c,item){
          let clss = ''
          if(item && item.value && item.value >= c.min && item.value < c.max){
            return 'showScore'
          }else{
            return ''
          }
      },
      setRageDotClass(index){
        let num = 1
        if(index < 2){
            num = 1;
        }
        else if(index < 3){
            num = 2;
        }
        else if(index < 3.5){
            num = 3;
        }
        else if(index < 4){
            num = 4;
        }
        else{
            num = 5;
        }
        return 'rage_dot' +  num
      },
      renderTable(){
          let indexNum = 0
          this.group.map(g=>{
              g.list.map(gl=>{
                  indexNum ++ ;
                  gl.index = indexNum + '. ';
                  gl.tItems = gl.items.shift()
                  
              })
          })
      }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  .fenge {
    height: 80px;
  }
  .table-list{
        page-break-inside: avoid;
  }
  table{
    width: 100%;
    background:#333;
    border:2px solid #333;
    td{
        padding: 4px 10px;
        text-align: center;
        font-size:12px;
        background:#fff;
        &.left{
            text-align: left;
            line-height: 18px;
            .index{
                font-size:15px;
                font-weight: bold;
                margin-bottom:8px;
            }
        }
        &.topChengdu1 .line-bottom{ background:#c00000;color:#fff; }
        &.topChengdu2 .line-bottom{ background:#ffc000;color:#333; }
        &.topChengdu3 .line-bottom{ background:#ffff00;color:#333; }
        &.topChengdu4 .line-bottom{ background:#92d050;color:#333; }
        &.topChengdu5 .line-bottom{ background:#00b050;color:#333; }
        &.topChengdu{ padding:4px 0px 0px !important; }
        &.chengdu1{ background:#dbe5f1; .showScore{ background:#c00000; } }
        &.chengdu2{ background:#b8cce4; .showScore{ background:#ffc000; } }
        &.chengdu3{ background:#95b3d7; .showScore{ background:#ffff00; } }
        &.chengdu4{ background:#365f91; .showScore{ background:#92d050; } }
        &.chengdu5{ background:#244061; .showScore{ background:#00b050; } }
        &.chengdu{
            width:55px;
            .showScore{
                width:15px;
                height:15px;
                border-radius: 15px;
                display: inline-block;
                border:1px solid #333;
                position: relative;
                top: 3px;
            }
        }
        &.score{
            position: relative;
            padding: 0px;
            .rage_box{
                .rage_dot{
                    position: absolute;
                    top:20px;
                    left:0px;
                    width:10px;
                    height:10px;
                    border-radius: 10px;
                }
            }
        }
    }
    tbody{
        line-height: 30px;
    }
    .toptr{
        td{
            color:#fff;
            background:#10253f;
            font-size:14px;
            font-weight: bolder;
            padding: 4px 0px;
        }
    }
    .middle{
        color:#333;
        background:#c6d9f1;
        font-size:16px;
        font-weight: bold;
    }
    .value{
        background: #fff;
        color:#333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataView/table/detail.vue